var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipLogosvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 1.5625H7.8125V6.08095L12.5 4.51847L17.1875 6.08097V1.5625Z",
    fill: "#499AC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 20.3125L3.125 10.9375L12.5 7.8125L21.875 10.9375L20.3125 20.3125H23.4375V23.4375H20.0116L16.4062 21.9953L12.5 23.5578L8.59375 21.9953L4.98841 23.4375H1.5625V20.3125H4.6875Z",
    fill: "#499AC8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipLogosvg);
export default __webpack_public_path__ + "static/media/ShipLogosvg.8a32b8426cffc3523539d70f67f28058.svg";
export { ForwardRef as ReactComponent };